import { Form, InputGroup } from "react-bootstrap";
import { CrudInputModel } from "./crudInputModel";
import { RequiredAsterisks } from "../../Asterisks/requiredAsterisks";

export const CrudNumberInput = ({
  validationSchema,
  form,
  name,
  label,
  disabled,
  t,
  inputGroupText,
  required,
}: CrudInputModel) => {
  return (
    <form.Field
      key={name}
      name={name}
      validators={{
        onSubmit: validationSchema,
      }}
    >
      {(field) => {
        const inputElement = (
          <Form.Control
            type="number"
            id={field.name}
            key={field.name}
            name={field.name}
            value={field.state.value}
            onBlur={field.handleBlur}
            onChange={(e) => {
              if (e.target.value === "") {
                field.handleChange(null);
              } else {
                field.handleChange(parseFloat(e.target.value));
              }
            }}
            isInvalid={field.state.meta.errors.length > 0}
            disabled={disabled}
          />
        );

        return (
          <Form.Group className="mb-3">
            <Form.Label>
              {label} {required && <RequiredAsterisks />}
            </Form.Label>
            {inputGroupText ? (
              <InputGroup>
                {inputElement}
                <InputGroup.Text>{inputGroupText}</InputGroup.Text>
              </InputGroup>
            ) : (
              inputElement
            )}
            {field.state.meta.errors && field.state.meta.errors[0] ? (
              <Form.Control.Feedback type="invalid">
                {t(field.state.meta.errors[0])}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
        );
      }}
    </form.Field>
  );
};
